const env = process.env;

const envoiroments = {
	development: {
		APIUrl: env.REACT_APP_API_GEARBOX_URL || 'http://localhost:8000',
		filesUrl: env.REACT_APP_API_GEARBOX_URL || 'http://localhost:8000',
		sitesUrl: 'http://plataforma.test',
		chamadosUrl: env.REACT_APP_CHAMADOS_URL || 'http://chamados.test',
		cockpitUrl: 'http://cockpit.com.br/',
		cockpitApi: 'https://hgb.webmotors.com.br/api',
		cockpitApiLogin: 'https://hk.webmotors.com.br/api',
		cockpitEstoque: 'https://hestoque.webmotors.com.br',
	},
	production: {
		APIUrl: 'https://apigb.webmotors.com.br',
		filesUrl: 'https://apigb.webmotors.com.br',
		sitesUrl: 'http://auth.sitewebmotors.com.br',
		chamadosUrl: 'http://chamados.vmwm.com.br',
		cockpitUrl: 'http://www.cockpit.com.br/',
		cockpitApi: 'https://gb.webmotors.com.br/api',
		cockpitApiLogin: '',
		cockpitEstoque: 'https://hestoque.webmotors.com.br',
	},
	test: {
		APIUrl: 'http://api.gearbox.webhub.com.br',
		filesUrl: 'http://api.gearbox.webhub.com.br',
		sitesUrl: 'http://plataforma.test',
		chamadosUrl: 'http://vm_chamados.test',
		cockpitUrl: 'http://cockpit.com.br/',
		cockpitApi: 'https://hgb.webmotors.com.br/api',
		cockpitApiLogin: '',
		cockpitEstoque: 'https://hestoque.webmotors.com.br',
	},
	staging: {
		APIUrl: 'https://api.gearbox.webhub.com.br',
		filesUrl: 'https://api.gearbox.webhub.com.br',
		sitesUrl: 'http://auth.hk.sitewebmotors.com.br',
		chamadosUrl: 'http://demochamados.vmwm.com.br',
		cockpitUrl: 'http://cockpit.com.br/',
		cockpitApi: 'https://azulgb.webmotors.com.br/api',
		cockpitApiLogin: '',
		cockpitEstoque: 'https://hestoque.webmotors.com.br',
	},
};

export default envoiroments[process.env.REACT_APP_ENV || 'development'];
